import { rem } from 'polished'

/**
 * Minimum right-panel width that can host the desktop multi-column list table
 * without cutting content. Below this, desktop snaps to the mobile card list.
 */
export const TRIP_LIST_DESKTOP_LAYOUT_MIN_WIDTH = 780

export const TRIP_LIST_MIN_WIDTH = rem(TRIP_LIST_DESKTOP_LAYOUT_MIN_WIDTH)
export const TRIP_LIST_GRID_COLUMNS = `${rem(40)} ${rem(128)} minmax(${rem(260)}, 1fr) minmax(${rem(104)}, ${rem(128)}) minmax(${rem(104)}, ${rem(112)}) minmax(${rem(144)}, ${rem(160)})`
export const TRIP_LIST_CONTENT_GRID_COLUMNS = `minmax(${rem(260)}, 1fr) minmax(${rem(104)}, ${rem(128)}) minmax(${rem(104)}, ${rem(112)}) minmax(${rem(144)}, ${rem(160)})`
